import React, { useEffect } from 'react';
import clsx from 'clsx';
import '../../../styling/Styles.css';
import SaveProjectPopUpWindow from '../PopUpsValidations/SaveProjectPopUpWindow';
import BuildUpsExitPopUpWindow from '../PopUpsValidations/BuildUpsExitPopUpWindow';
import ChangePagePopUpWindow from '../PopUpsValidations/ChangePagePopUpWindow';
import ChangeProjectPopUpWindow from '../PopUpsValidations/ChangeProjectPopUpWindow';
import {
  SelectProject,
  SelectPage,
  ExportProjectCode,
  ViewDataModel,
  ViewDataFlow,
  DeployButton,
  ViewProjectQuality,
  AuthenticateButton
} from '../../BreadcrumbComponents/index';

import { loadUIelements, clearUIelements } from '../handleStoreElements';

/**
 *
 * @param {number} props.selectedPage - index in localeStorage of user's selected page
 * @param {number} props.selectedProject - index in localStorage of user's selected project
 * @param {[][]} props.savedPagesPerProject - 2d array with save status for all pages of every project
 * @param {setState} props.setSavedPagesPerProject - hook method to handle savedPagesPerProject variable
 * @param {setState} props.setSelectedProject - hook method to handle selectedProject variable
 * @param {setState} props.setSelectedPage - hook method to handle selectedPage variable
 * @param {object} props.editor - grapesJs editor
 * @param {[][]} props.projectNamesPages - 2d array with the page names for all projects
 * @param {setState} props.setProjectNamesPages - hook method to handle projectNamesPages variable
 * @param {method} props.savedPageClicked - method that saves page for a project
 * @param {boolean} props.displaySpinner - variable that shows/hides load page spinner
 * @param {setState} props.setDisplaySpinner - hook method to handle displaySpinner variable
 * @param {setState} props.setDisplayProjectSpinner - hook method to handle displayProjectSpinner variable. This variable displays/hides load project spinner
 * @param {setState} props.setDisplayExportBackendSpinner - hook method to handle displayExportBackendSpinner variable. This variable displays/hides load export backend spinner
 * @param {setState} props.setDisplayExportFrontSdkSpinner - hook method to handle displayExportFrontSdkSpinner variable. This variable displays/hides load export front sdk spinner
 * @param {setState} props.setDisplaySyncToGithubSpinner - hook method to handle displaySyncToGithubSpinner variable. This variable displays/hides load sync to Github spinner
 * @param {setState} props.setDisplayWentWrongUi - hook method to handle displayWentWrongUi. This variable displays/hides display went wrong middle layer
 * @param {boolean} props.enableBreadCrumb - shows if onclick functions in breadcrumb are enabled/disabled
 * @returns buildApp's page breadcrumb
 */
const BuildAppsBreadcrumb = (props) => {
  const {
    selectedPage,
    selectedProject,
    savedPagesPerProject,
    setSavedPagesPerProject,
    setSelectedProject,
    setSelectedPage,
    editor,
    projectNamesPages,
    setProjectNamesPages,
    savedPageClicked,
    displaySpinner,
    setDisplaySpinner,
    setDisplayProjectSpinner,
    setDisplayExportBackendSpinner,
    setDisplayExportFrontSdkSpinner,
    setDisplaySyncToGithubSpinner,
    setDisplayWentWrongUi,
    enableBreadCrumb
  } = props;

  const [alertSaveProject, setAlertSaveProject] = React.useState(false); // hook variable that displays/hides save all pages pop up
  const [aboutToViewProjectDataModel, setAboutToViewProjectDataModel] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to navigate to view_project_data_model page
  const [aboutToViewPageDataModel, setAboutToViewPageDataModel] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to navigate to view_page_data_model page
  const [aboutToViewPageFlow, setAboutToViewPageFlow] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to navigate to view_page_flow page
  const [aboutToViewProjectFlow, setAboutToViewProjectFlow] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to navigate to view_project_flow page
  const [aboutToViewServerQuality, setAboutToViewServerQuality] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to navigate to server_project_quality page
  const [aboutToViewFrontQuality, setAboutToViewFrontQuality] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to navigate to front_project_quality page
  const [alertExitBuildUps, setAlertExitBuildUps] = React.useState(false); // hook variable that is used to display/hide buildUpsExitPopUpWindow pop up
  const [aboutToLogout] = React.useState(false); // hook variable that is used in confirm button of buildUpsExitPopUpWindow pop up in order to log out

  const [openChangePage, setOpenChangePage] = React.useState(false); // hook variable that is used to display ChangePagePopUpWindow pop up when there is an unsaved page and user wants to change page
  const [openChangeProject, setOpenChangeProject] = React.useState(false); // hook variable that is used to display  ChangeProjectPopUpWindow pop up when there is an unsaved page and user wants to change project
  const [tempIndexProject, setTempIndexProject] = React.useState(-1); // hook variable that is used to store index of page that user has selected to navigate
  const [tempIndexPage, setTempIndexPage] = React.useState(-1); // hook variable that is used to store index of project that user has selected to navigate

  // Open save all pages pop up
  const openPopUP = () => {
    setAlertSaveProject(true);
  };

  // Function that returns true/false if page is saved
  const needSave = () => {
    let need = false;

    if (savedPagesPerProject[selectedProject][selectedPage] === false) {
      need = true;
    }
    return need;
  };

  // Function that handles change project
  const changeProject = (option) => {
    let index = 0;

    // Find index of clicked project
    JSON.parse(localStorage.getItem('data')).forEach((element, indexEl) => {
      if (element.name === option) {
        index = indexEl;
      }
    });

    // Check if current page is saved and if current project is different than the index of the clicked project
    if (
      (savedPagesPerProject[selectedProject][selectedPage] !== false || selectedPage < 0) &&
      selectedProject !== index
    ) {
      editor.runCommand('enable-navigate-page'); // Run grapesJs command enable-navigate-page.
      const tempData = JSON.parse(localStorage.getItem('data'))[index].pages;

      const tempProject = JSON.parse(localStorage.getItem('data'))[index];
      localStorage.setItem('current_project', JSON.stringify(tempProject));

      setSelectedProject(index); // Update index of selectedProject
      setDisplayProjectSpinner(true); // Display load project's data spinner
      if (tempData.length > 0) {
        setSelectedPage(0); // Render first page of project
        clearUIelements(editor); // Clear canvas
        loadUIelements(editor, 0, index); // Load data for clicked project
      } else {
        setSelectedPage(-1); // If project has no pages set selected page to -1
      }

      editor.Panels.getButton('panel-switcher', 'show-blocks').set('active', true); // Enable 'blocks' tab next to grapesJs editor
    }
    // if current page is unsaved and index of clicked project is different than selected project then open ChangePagePopUpWindow pop up
    else if (selectedProject !== index) {
      setTempIndexProject(index);
      setTempIndexPage(-1);
      setOpenChangeProject(true); // open ChangePagePopUpWindow pop up
    }
  };

  // Function that handles change page
  const changePagePerProjectTable = (index) => {
    // Check if current page is saved
    if (savedPagesPerProject[selectedProject][selectedPage] !== false) {
      editor.runCommand('enable-navigate-page'); // run grapesJs command enable-navigate-page
      localStorage.setItem('selectedPage', index);
      setSelectedPage(index); // update selected page
      setDisplaySpinner(true); // enable display spinner
    }
    // Display ChangePagePopUpWindow pop up
    else {
      setTempIndexPage(index);
      setTempIndexProject(selectedProject);
      setOpenChangePage(true); // open ChangePagePopUpWindow pop up
    }
  };

  /**
   * useEffect that loads page every time that displaySpinner is set to true.This happens when page is saved and user navigates
   * to another page or when page is unsaved, then ChangePagePopUpWindow pop up is appeared and user clicks confirm
   */
  useEffect(() => {
    if (displaySpinner === true) {
      const newContent = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[
        selectedPage
      ].html;
      clearUIelements(editor); // clear canvas
      loadUIelements(editor, selectedPage, selectedProject); // load new page
      if (
        newContent === undefined ||
        newContent === '' ||
        newContent === ' ' ||
        newContent === null ||
        editor.getHtml() === ''
      )
        setDisplaySpinner(false); // hide load page spinner
      editor.Commands.run('show-tabs-panel');
      editor.stopCommand('enable-navigate-page');
    }
  }, [displaySpinner]);

  return (
    <>
      <div className={clsx('BuildAppsBreadcrumb')} style={{ backgroundColor: '#CFD8E0' }}>
        {enableBreadCrumb === false && (
          <span
            style={{
              position: 'absolute',
              height: '100%',
              width: '100vw',
              backgroundColor: 'rgb(18, 65, 107',
              opacity: '0.75'
            }}
          />
        )}
        <div
          className={clsx('generalMarg', 'flexRowDirection')}
          style={{ justifyContent: 'space-between' }}
        >
          <div className={clsx('flexRowDirection')} style={{ width: '75%', padding: '0vw' }}>
            <SelectProject changeProject={changeProject} selectedProject={selectedProject} />
            <SelectPage
              projectNamesPages={projectNamesPages}
              setProjectNamesPages={setProjectNamesPages}
              selectedPage={selectedPage}
              selectedProject={selectedProject}
              savedPagesPerProject={savedPagesPerProject}
              setSavedPagesPerProject={setSavedPagesPerProject}
              changePagePerProjectTable={changePagePerProjectTable}
              setSelectedPage={setSelectedPage}
            />
          </div>
          <div className={clsx('flexRowDirection')}>
            <ExportProjectCode
              setDisplayExportBackendSpinner={setDisplayExportBackendSpinner}
              setDisplayExportFrontSdkSpinner={setDisplayExportFrontSdkSpinner}
              setDisplayWentWrongUi={setDisplayWentWrongUi}
              setDisplaySyncToGithubSpinner={setDisplaySyncToGithubSpinner}
              enableBreadCrumb={enableBreadCrumb}
            />
            <ViewDataModel
              needSave={needSave}
              setAboutToViewPageDataModel={setAboutToViewPageDataModel}
              setAboutToViewProjectDataModel={setAboutToViewProjectDataModel}
              savedPageClicked={savedPageClicked}
              setAlertExitBuildUps={setAlertExitBuildUps}
              enableBreadCrumb={enableBreadCrumb}
            />
            <ViewDataFlow
              needSave={needSave}
              setAboutToViewPageFlow={setAboutToViewPageFlow}
              setAboutToViewProjectFlow={setAboutToViewProjectFlow}
              setAlertExitBuildUps={setAlertExitBuildUps}
              savedPageClicked={savedPageClicked}
              enableBreadCrumb={enableBreadCrumb}
            />
            <DeployButton enableBreadCrumb={enableBreadCrumb} selectedProject={selectedProject} />
            <AuthenticateButton
              enableBreadCrumb={enableBreadCrumb}
              selectedProject={selectedProject}
            />

            <ViewProjectQuality
              enableBreadCrumb={enableBreadCrumb}
              setAboutToViewFrontQuality={setAboutToViewFrontQuality}
              setAboutToViewServerQuality={setAboutToViewServerQuality}
              needSave={needSave}
              savedPageClicked={savedPageClicked}
              setAlertExitBuildUps={setAlertExitBuildUps}
            />
            {enableBreadCrumb === true ? (
              <div
                data-tooltip="Save Project"
                data-tooltip-pos="bottom"
                className={clsx('fas', 'fa-save', 'fa-save2', 'teamSelector')}
                onClick={openPopUP}
                style={{ marginTop: '0.5vw' }}
                aria-hidden="true"
              />
            ) : (
              <div
                className={clsx('fas', 'fa-save', 'fa-save3')}
                style={{ marginTop: '0.5vw', transform: 'translate(-50%, 0)' }}
              />
            )}
          </div>
        </div>
      </div>
      <SaveProjectPopUpWindow
        openAlert={alertSaveProject}
        setOpenAlert={setAlertSaveProject}
        savedPageClicked={savedPageClicked}
      />

      <BuildUpsExitPopUpWindow
        openAlert={alertExitBuildUps}
        setOpenAlert={setAlertExitBuildUps}
        aboutToLogout={aboutToLogout}
        savedPageClicked={savedPageClicked}
        aboutToViewPageDataModel={aboutToViewPageDataModel}
        setAboutToViewPageDataModel={setAboutToViewPageDataModel}
        aboutToViewProjectDataModel={aboutToViewProjectDataModel}
        setAboutToViewProjectDataModel={setAboutToViewProjectDataModel}
        aboutToViewPageFlow={aboutToViewPageFlow}
        setAboutToViewPageFlow={setAboutToViewPageFlow}
        aboutToViewProjectFlow={aboutToViewProjectFlow}
        setAboutToViewProjectFlow={setAboutToViewProjectFlow}
        aboutToViewFrontQuality={aboutToViewFrontQuality}
        setAboutToViewFrontQuality={setAboutToViewFrontQuality}
        aboutToViewServerQuality={aboutToViewServerQuality}
        setAboutToViewServerQuality={setAboutToViewServerQuality}
      />
      <ChangePagePopUpWindow
        editor={editor}
        openAlert={openChangePage}
        setOpenAlert={setOpenChangePage}
        savedPagesPerProject={savedPagesPerProject}
        setSavedPagesPerProject={setSavedPagesPerProject}
        projectNamesPages={projectNamesPages}
        indexPage={tempIndexPage}
        indexProject={tempIndexProject}
        setSelectedPage={setSelectedPage}
        setSelectedProject={setSelectedProject}
        selectedProject={selectedProject}
        selectedPage={selectedPage}
        savedPageClicked={savedPageClicked}
        setDisplaySpinner={setDisplaySpinner}
      />
      <ChangeProjectPopUpWindow
        openAlert={openChangeProject}
        setOpenAlert={setOpenChangeProject}
        savedPagesPerProject={savedPagesPerProject}
        setSavedPagesPerProject={setSavedPagesPerProject}
        projectNamesPages={projectNamesPages}
        indexProject={tempIndexProject}
        setSelectedPage={setSelectedPage}
        setSelectedProject={setSelectedProject}
        selectedProject={selectedProject}
        selectedPage={selectedPage}
        savedPageClicked={savedPageClicked}
        setDisplayProjectSpinner={setDisplayProjectSpinner}
        editor={editor}
      />
    </>
  );
};

export default BuildAppsBreadcrumb;
